<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            <DropdownColumns v-model="fields" class="customize" />
          </div>
          <b-table
            id="users-table"
            :busy.sync="isBusy"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :hover="true"
            :striped="true"
            :bordered="false"
            stacked="md"
            v-model="copy"
            :items="provider"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="rowClicked"
            tbody-tr-class="tr-pointer"
            v-columns-resizable="{afterResize: columnsWidthChanged}"
          >
            <template v-slot:empty="scope">
              <div class="text-center">{{ $t(scope.emptyText) }}</div>
            </template>
            <template v-slot:head(selected)>
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop @change="selectAll" v-model="checkAll" />
                <span></span>
              </label>
            </template>
            <template v-slot:head(username)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(surname)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(cnp)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(email_address)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(phone_number)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(flags)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(etenant_ids)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(epermission_role_ids)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(discrete_permissions)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(eshop_group_ids)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(eshop_ids)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(force_2fa)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(enabled_2fa)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(allowed_ips)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(working_hours)="data">{{ $t(data.label) }}</template>

            <template v-slot:cell(flags)="data">{{ data.value ? "Inactive" : "Active" }}</template>

            <template v-slot:cell(etenant_ids)="data">
              [
              <span v-for="(item, index) in data.value" :key="index">
                <span v-if="item.to">
                  <router-link :to="`/tenants/${item.to}`">{{ item.name }}</router-link>
                </span>
                <span v-else>{{ item.name }}</span>
                <span v-if="index < data.value.length-1">,&nbsp;</span>
              </span>
              ]
            </template>

            <template v-slot:cell(epermission_role_ids)="data">
              [
              <span v-for="(item, index) in data.value" :key="index">
                <span v-if="item.to">
                  <router-link :to="`/roles/${item.to}`">{{ item.name }}</router-link>
                </span>
                <span v-else>{{ item.name }}</span>
                <span v-if="index < data.value.length-1">,&nbsp;</span>
              </span>
              ]
            </template>

            <template v-slot:cell(eshop_group_ids)="data">
              [
              <span v-for="(item, index) in data.value" :key="index">
                <span v-if="item.to">
                  <router-link :to="`/shop-groups/${item.to}`">{{ item.name }}</router-link>
                </span>
                <span v-else>{{ item.name }}</span>
                <span v-if="index < data.value.length-1">,&nbsp;</span>
              </span>
              ]
            </template>

            <template v-slot:cell(eshop_ids)="data">
              [
              <span v-for="(item, index) in data.value" :key="index">
                <span v-if="item.to">
                  <router-link :to="`/shops/${item.to}`">{{ item.name }}</router-link>
                </span>
                <span v-else>{{ item.name }}</span>
                <span v-if="index < data.value.length-1">,&nbsp;</span>
              </span>
              ]
            </template>

            <template v-slot:cell(selected)="data">
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop :value="data.item.eid" v-model="selected" />
                <span></span>
              </label>
            </template>
          </b-table>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <BulkActionSelect
                  v-model="bulkAction"
                  :options="bulkActionOptions"
                  variant="light"
                  class="mr-2"
                  size="sm"
                  v-if="selected.length"
                />
                <b-button
                  @click.stop="applySelected()"
                  size="sm"
                  class="mr-2 refresh"
                  variant="light"
                  v-if="selected.length"
                  :disabled="!bulkAction"
                >{{$t('Apply')}}</b-button>
                <span class="pagination-sep" v-if="selected.length"></span>

                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  @click.stop="$root.$emit('bv::refresh::table', 'users-table')"
                  size="sm"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-edit" size="custom" scrollable>
      <template slot="modal-title">{{$t('User')}}</template>
      <template slot="modal-header-close">
        <span />
      </template>
      <User :selectedeid="selectedeid" />
    </b-modal>
  </div>
</template>

<script>
import startCase from "@/shared/strings";
import { evbus, EVENTS } from "@/shared/evbus";
import { successConf, errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import BulkActionSelect from "@/components/BulkActionSelect";
import PaginationSelect from "@/components/PaginationSelect";
import TableFilters from "@/components/TableFilters";
import DropdownColumns from "@/components/DropdownColumns";
import User from "./User";

export default {
  name: "users",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    TableFilters,
    DropdownColumns,
    BulkActionSelect,
    User,
  },
  data: function () {
    return {
      tableName: "users",

      bulkAction: null,
      bulkActionOptions: [
        { text: "Activate Users", field: "flags", value: 0 },
        { text: "Inactivate Users", field: "flags", value: 1 },
      ],

      filterOptions: [
        {
          field: "tenant_ids",
          multiple: true,
          placeholder: "Tenants",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          options: [],
          selected: [],
        },
        {
          field: "shop_group_ids",
          multiple: true,
          placeholder: "Groups",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shopGroups",
          options: [],
          selected: [],
        },
        {
          field: "shop_ids",
          multiple: true,
          placeholder: "Shops",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shops",
          options: [],
          selected: [],
        },
        {
          field: "permission_role_ids",
          multiple: true,
          placeholder: "Roles",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "roles",
          options: [],
          selected: [],
        },
        {
          field: "discrete_permissions",
          multiple: true,
          placeholder: "Permissions",
          trackBy: "name",
          label: "name",
          translate: false,
          store: "permissions",
          options: [],
          selected: [],
        },
        {
          field: "flags",
          multiple: false,
          placeholder: "Status",
          options: [
            { name: "Active Users", value: 0 },
            { name: "Inactive Users", value: 1 },
          ],
          selected: [],
        },
      ],

      isBusy: false,
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "selected",
          selected: false,
          ignore: true,
          class: "mw-select",
          dpIgnore: true,
        },
        {
          key: "eid",
          label: "Id",
          sortable: false,
          class: "d-none",
          ignore: true,
        },
        { key: "username", sortable: true, class: "" },
        { key: "name", sortable: true, class: "" },
        { key: "cnp", label: "CNP", sortable: true, class: "" },
        { key: "surname", sortable: true, class: "" },
        { key: "email_address", sortable: true, class: "" },
        { key: "phone_number", sortable: true, class: "" },
        {
          key: "flags",
          label: "Is Active",
          sortable: true,
          ignore: true,
          class: "",
        },
        {
          key: "etenant_ids",
          label: "Tenants",
          sortable: false,
          class: "d-none",
          ignore: true,
        },
        {
          key: "epermission_role_ids",
          label: "Roles",
          sortable: false,
          class: "d-none",
          ignore: true,
        },
        {
          key: "discrete_permissions",
          sortable: true,
          class: "d-none",
          ignore: true,
        },
        {
          key: "eshop_group_ids",
          label: "Shop Groups",
          sortable: false,
          class: "d-none",
          ignore: true,
        },
        {
          key: "eshop_ids",
          label: "Shops",
          sortable: false,
          class: "d-none",
          ignore: true,
        },
        {
          key: "force_2fa",
          sortable: true,
          ignore: true,
          class: "d-none",
        },
        {
          key: "enabled_2fa",
          sortable: true,
          ignore: true,
          class: "d-none",
        },
        {
          key: "allowed_ips",
          label: "Allowed IPs",
          sortable: false,
          ignore: true,
          class: "d-none",
        },
        {
          key: "working_hours",
          sortable: false,
          ignore: true,
          class: "d-none",
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      selected: [],
      copy: null,
      addLabel: "Add user",
      days: {
        1: "Monday",
        2: "Tuesday",
        3: "Wednesday",
        4: "Thursday",
        5: "Friday",
        6: "Saturday",
        7: "Sunday",
      },

      selectedeid: "",
    };
  },
  watch: {
    selected(val) {
      if (val.length != this.copy.length) {
        this.checkAll = false;
      }
    },
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "users-table");
    },
    selectAll() {
      this.selected = [];
      this.copy.forEach((item) => {
        if (this.checkAll) {
          this.selected.push(item.eid);
        }
      });
    },
    applySelected() {
      const loading = this.$loading.open({
        container: this.$refs.cnt,
      });

      const bulkData = {
        field: this.bulkAction.field,
        value: this.bulkAction.value,
        ids: this.selected,
      };

      this.$store.dispatch("user/bulkAction", bulkData).finally(() => {
        loading.close();
        this.allSelected = false;
        this.selected = [];
        this.$root.$emit("bv::refresh::table", "users-table");
      });
    },
    provider(ctx, callback) {
      const self = this;
      const loading = this.$loading.open({
        container: this.$refs.cnt,
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach((item) => {
        if (item.selected.length) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach((el) => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      let tenantIDs = {};
      let roleIDs = {};
      let shopGroupIDs = {};
      let shopIDs = {};

      this.$store
        .dispatch("user/fetch", paginationData)
        .then((resp) => {
          this.totalRows = resp.data.total;

          resp.data.rows.forEach((item, index) => {
            if (!item.flags) {
              resp.data.rows[index]["_cellVariants"] = {
                flags: "success",
              };
            } else {
              resp.data.rows[index]["_cellVariants"] = {
                flags: "danger",
              };
            }

            if (item.working_hours) {
              const tmp = [];
              for (let i = 0; i < item.working_hours.length; i += 3) {
                tmp.push([
                  this.days[item.working_hours[i]],
                  this.minutesToHours(item.working_hours[i + 1]),
                  this.minutesToHours(item.working_hours[i + 2]),
                ]);
              }
              item.working_hours = tmp;
            }

            const tenants = {};

            if (item.etenant_ids) {
              for (let i = 0; i < item.etenant_ids.length; i += 1) {
                const tid = item.etenant_ids[i];
                tenantIDs[tid] = true;
              }
            }

            if (item.epermission_role_ids) {
              for (let i = 0; i < item.epermission_role_ids.length; i += 1) {
                const rid = item.epermission_role_ids[i];
                roleIDs[rid] = true;
              }
            }

            if (item.eshop_group_ids) {
              for (let i = 0; i < item.eshop_group_ids.length; i += 1) {
                const rid = item.eshop_group_ids[i];
                shopGroupIDs[rid] = true;
              }
            }

            if (item.eshop_ids) {
              for (let i = 0; i < item.eshop_ids.length; i += 1) {
                const rid = item.eshop_ids[i];
                shopIDs[rid] = true;
              }
            }
          });

          Promise.all([
            this.$store.dispatch("cacheOnDemand/fetch", {
              key: "tenants",
              ids: Object.keys(tenantIDs),
            }),
            this.$store.dispatch("cacheOnDemand/fetch", {
              key: "roles",
              ids: Object.keys(roleIDs),
            }),
            this.$store.dispatch("cacheOnDemand/fetch", {
              key: "shopGroups",
              ids: Object.keys(shopGroupIDs),
            }),
            this.$store.dispatch("cacheOnDemand/fetch", {
              key: "shops",
              ids: Object.keys(shopIDs),
            }),
          ])
            .then(([tenantsData, rolesData, shopGroupsData, shopsData]) => {
              // console.log("tenants", tenants);
              // console.log("roles", roles);
              // console.log("shopGroups", shopGroups);
              // console.log("shops", shops);

              resp.data.rows.forEach((item, index) => {
                const tenants = {};

                if (item.etenant_ids) {
                  const tmp = [];
                  for (let i = 0; i < item.etenant_ids.length; i += 1) {
                    const tid = item.etenant_ids[i];
                    const data = tenantsData[tid];
                    if (data) {
                      tmp.push({ to: tid, name: data.brand_name });
                      tenants[data.all_shops_id] = data;
                    } else {
                      tmp.push({ to: null, name: tid });
                    }
                  }
                  item.etenant_ids = tmp;
                }

                if (item.epermission_role_ids) {
                  const tmp = [];
                  for (
                    let i = 0;
                    i < item.epermission_role_ids.length;
                    i += 1
                  ) {
                    const rid = item.epermission_role_ids[i];
                    const data = rolesData[rid];
                    if (data) {
                      tmp.push({ to: rid, name: data.name });
                    } else {
                      tmp.push({ to: null, name: rid });
                    }
                  }
                  item.epermission_role_ids = tmp;
                }

                if (item.eshop_group_ids) {
                  const tmp = [];
                  for (let i = 0; i < item.eshop_group_ids.length; i += 1) {
                    const rid = item.eshop_group_ids[i];
                    const data = shopGroupsData[rid];
                    if (data) {
                      tmp.push({ to: rid, name: data.name });
                    } else {
                      tmp.push({ to: null, name: rid });
                    }
                  }
                  item.eshop_group_ids = tmp;
                }

                if (item.eshop_ids) {
                  const tmp = [];
                  for (let i = 0; i < item.eshop_ids.length; i += 1) {
                    const rid = item.eshop_ids[i];
                    const data = shopsData[rid];
                    if (data) {
                      tmp.push({ to: rid, name: data.name });
                    } else {
                      if (typeof tenants[rid] !== "undefined") {
                        tmp.push({
                          to: null,
                          name: tenants[rid].brand_name + " - All Shops",
                        });
                      } else {
                        tmp.push({ to: null, name: rid });
                      }
                    }
                  }
                  item.eshop_ids = tmp;
                }
              });
            })
            .catch((err) => {
              this.$bvToast.toast(
                this.$t(err.message),
                errorConf(this.$t("Error"))
              );
            });

          callback(resp.data.rows);
        })
        .catch((err) => {
          debugger;
          this.$bvToast.toast(
            this.$t(err.message),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      //this.selectedeid = item.eid;
      //this.$bvModal.show("modal-edit");
      //return;
      this.$router.push("/users/" + item.eid);
    },
    redirect() {
      //this.selectedeid = "";
      //this.$bvModal.show("modal-edit");
      //return;
      this.$router.push("/users/0");
    },
    minutesToHours(total) {
      const minutes = total % 60;
      const hours = (total - minutes) / 60;
      return (
        (hours < 10 ? `0${hours}` : hours) +
        ":" +
        (minutes < 10 ? `0${minutes}` : minutes)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
